module.exports = __webpack_public_path__ + "img/safari2.c86a881e.png";